import BlueDotsBackground from '../../BlueDotsBackground';

export default function DisputePortal() {
  return (
    <>
      <BlueDotsBackground />
      <section
        id="hero"
        className="relative text-center text-white overflow-hidden font-sans"
      >
        <div className="relative z-10 px-6 min-h-screen flex flex-col justify-center">
          <div className="max-w-5xl mx-auto">
            <h1 className="text-4xl md:text-6xl font-semibold tracking-tight leading-tight mb-8">
              Are disputes slowing down your Government Reimbursement team?
            </h1>
            <p className="text-lg md:text-2xl text-gray-300 font-light mb-12">
              Kernel’s centralized Dispute Portal streamlines resolution
              workflows across multiple parties including CMS, covered entities,
              and legal teams. Gain full visibility, accelerate turnaround
              times, and ensure accountability, traceability, and compliance
              every step of the way.
            </p>
            <div className="max-w-xl w-full mx-auto mb-20"></div>
          </div>
        </div>
      </section>
    </>
  );
}
